export default __webpack_public_path__ + "static/media/0xd6df932a45c0f255f85145f286ea0b292b21c90b.731f879b.webp";